module.exports = __webpack_public_path__ + "static/english-for-kids-980ee25073c91298102ae2b963504a3e.jpg";